import { ATSConnectHiringRequestTestIds } from 'data-testids/ATS';
import { HeaderContainer, Title } from '../../styles/hiringRequestStyles';
import React from 'react';

export const HiringRequestListHeader: React.FC = () => {
  return (
    <HeaderContainer>
      <Title data-testid={ATSConnectHiringRequestTestIds.HIRING_REQUEST_TITLE} variant="h2">
        Connect candidates
      </Title>
    </HeaderContainer>
  );
};
